import { render, staticRenderFns } from "./AmenityDetail.vue?vue&type=template&id=7313e434&"
import script from "./AmenityDetail.vue?vue&type=script&lang=js&"
export * from "./AmenityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports